import { useState, useEffect } from "react";
import CONFIG from "../config";

function ipToInt(ip) {
  return ip.split(".").reduce((acc, oct) => (acc << 8) + parseInt(oct, 10), 0) >>> 0;
}

function cidrContains(cidr, ip) {
  try {
    const [range, bits] = cidr.split("/");
    const mask = bits ? ~((1 << (32 - parseInt(bits))) - 1) >>> 0 : 0xffffffff;
    return (ipToInt(range) & mask) === (ipToInt(ip) & mask);
  } catch {
    return false;
  }
}

export default function useVisitorInfo() {
  const [visitorInfo, setVisitorInfo] = useState(null);
  const [allowed, setAllowed] = useState(null); // null = checking

  useEffect(() => {
    async function check() {
      try {
        // 1. Get IP
        const ipRes = await fetch("https://api.ipify.org?format=json");
        const { ip } = await ipRes.json();

        // 2. Get geo/ASN/ISP info
        const geoRes = await fetch(`https://ipapi.co/${ip}/json/`);
        const geo = await geoRes.json();

        const info = {
          ip,
          asn: geo.asn || "Unknown",
          isp: geo.org || "Unknown",
          city: geo.city || "",
          region: geo.region || "",
          country: geo.country_name || "",
          location: [geo.city, geo.region, geo.country_code].filter(Boolean).join(", "),
        };

        setVisitorInfo(info);

        // 3. Load allowlists
        const [asnText, ipText] = await Promise.all([
          fetch("/asn.txt").then((r) => r.text()),
          fetch("/ip_range.txt").then((r) => r.text()),
        ]);

        const allowedASNs = asnText
          .split("\n")
          .map((l) => l.trim())
          .filter((l) => l && !l.startsWith("#"));

        const allowedCIDRs = ipText
          .split("\n")
          .map((l) => l.trim())
          .filter((l) => l && !l.startsWith("#"));

        // 4. Check access
        const asnMatch = allowedASNs.some(
          (a) => a.toUpperCase() === (info.asn || "").toUpperCase()
        );
        const cidrMatch = allowedCIDRs.some((cidr) => cidrContains(cidr, ip));

        if (asnMatch || cidrMatch) {
          setAllowed(true);
        } else {
          setAllowed(false);
          window.location.href = CONFIG.REDIRECT_URL;
        }
      } catch (err) {
        console.error("Access check failed", err);
        // Fail open — show page if check errors
        setAllowed(true);
        setVisitorInfo({ ip: "Unknown", asn: "Unknown", isp: "Unknown", location: "Unknown" });
      }
    }

    check();
  }, []);

  return { visitorInfo, allowed };
}
